"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPaypalJs = require("@paypal/react-paypal-js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _fieldsMessages = require("../../fields/fieldsMessages");
var _PaypalCheckoutContainer = _interopRequireDefault(require("./PaypalCheckoutContainer"));
require("../../../style/paypal/main.css");
var _contexts = require("../../../contexts");
var _commonUtils = require("../../../utils/commonUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PayPalBtn = function PayPalBtn(props) {
  var inputCustomData = props.inputCustomData,
    customAuthCallBack = props.customAuthCallBack,
    customFunctions = props.customFunctions,
    setProcessing = props.setProcessing;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    paypalComponent = _useState2[0],
    setPaypalComponent = _useState2[1];
  var _useContext = (0, _react.useContext)(_contexts.PaypalContext),
    _useContext$state = _useContext.state,
    clientId = _useContext$state.clientId,
    userData = _useContext$state.userData,
    bnCode = _useContext$state.bnCode;
  var _inputCustomData$cart = inputCustomData.cart,
    currencyCode = _inputCustomData$cart.currencyCode,
    languageCode = _inputCustomData$cart.languageCode;
  var locale = (0, _commonUtils.convertBCP2Locale)(languageCode);
  (0, _react.useEffect)(function () {
    if (clientId) {
      setPaypalComponent( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactPaypalJs.PayPalScriptProvider, {
        options: {
          'client-id': clientId,
          currency: currencyCode,
          intent: 'authorize',
          locale: locale,
          commit: false,
          'data-partner-attribution-id': bnCode ? bnCode : ''
        },
        deferLoading: true
      }, /*#__PURE__*/_react.default.createElement(_PaypalCheckoutContainer.default, {
        currency: currencyCode,
        customAuthCallBack: customAuthCallBack,
        customFunctions: customFunctions,
        inputCustomData: inputCustomData,
        locale: locale,
        setProcessing: setProcessing
      }))));
    }
  }, [clientId]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "paypal-container"
  }, paypalComponent, /*#__PURE__*/_react.default.createElement("div", {
    className: "paypal-container__message"
  }, userData ? /*#__PURE__*/_react.default.createElement("p", {
    className: "paypal-container__message_success"
  }, ' ', formatMessage(_fieldsMessages.payPalMessages.success), ' ') : /*#__PURE__*/_react.default.createElement("p", {
    className: "paypal-container__message_initial"
  }, ' ', formatMessage(_fieldsMessages.payPalMessages.initial), ' '))));
};
PayPalBtn.propTypes = {
  inputCustomData: _propTypes.default.object.isRequired,
  customAuthCallBack: _propTypes.default.func.isRequired,
  customFunctions: _propTypes.default.object,
  setProcessing: _propTypes.default.func.isRequired
};
var _default = PayPalBtn;
exports.default = _default;